module.exports = __webpack_public_path__ + "static/img/PVC_ISO9001.410b619f.jpg";